import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Navigation from './components/Navigation';
import MatchDetail from './components/MatchDetail';
import MatchesTable from './components/MatchesTable';
import MatchesCalendar from './components/MatchesCalendar';
import TeamsTable from './components/TeamsTable';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2rkx33ca129lf">
      <div className="bg-gray-50 min-h-screen w-full" data-id="element-1" data-mp="2rkdvopi073ln">
        <Navigation data-id="element-2" data-mp="2rl6y5e9xj6xz" />
        <div className="pt-6" data-id="element-3" data-mp="2mlu9qp3etrta">
          <Routes data-id="element-4" data-mp="2mmluf4vgy54s">
            <Route path="/matches/table" element={<MatchesTable data-id="element-6" data-mp="2mjzo18kbdvo5" />} data-id="element-5" data-mp="2mn5a0exnchfn" />
            <Route path="/matches/calendar" element={<MatchesCalendar data-id="element-8" data-mp="31c9ygdv1bhw7" />} data-id="element-7" data-mp="31b8lg3ugklbu" />
            <Route path="/matches/:matchId" element={<MatchDetail data-id="element-10" data-mp="2wiywor52xrb5" />} data-id="element-9" data-mp="2wk0b95lb0vxm" />
            <Route path="/teams/all" element={<TeamsTable data-id="element-12" data-mp="28u5yeo0zj7dd" />} data-id="element-11" data-mp="2wip6p3k1bk5g" />
            <Route path="/" element={<Navigate to="/matches/1" replace data-id="element-14" data-mp="28s2ztflro5x1" />} data-id="element-13" data-mp="28te21azkd5m1" />
          </Routes>
        </div>
      </div>
    </BrowserRouter>;
}